{
  "schema": 1,
  "issuer": "https://auth.dev.iot.creavision.tech/realms/customers",
  "global_api": "https://dev.iot.creavision.tech",
  "regions": [
    {
      "id": "eu1",
      "jurisdiction": "EU",
      "status": "open",
      "api": "https://dev.iot.creavision.tech",
      "web": "https://dev.iot.creavision.tech",
      "ingest": "ingest.dev.iot.creavision.tech",
      "feed": "pub-mqtt.dev.iot.creavision.tech",
      "issuer": "https://auth.dev.iot.creavision.tech/realms/customers",
      "api_version": "0.53.0",
      "maps": "https://dev.iot.creavision.tech/maps/style/"
    }
  ]
}
